import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import logo from "@/assets/logo.webp";
import LanguageSwitcher from "@/components/landing/LanguageSwitcher";

const LandingNav = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 glass border-b border-border/50">
      <div className="container mx-auto flex items-center justify-between h-16 px-4">
        <Link to="/" className="flex items-center gap-2">
          <img src={logo} alt="LineupSync team management logo" width={32} height={32} className="w-8 h-8 rounded-lg object-contain" />
          <span className="font-display font-bold text-xl text-foreground">LineupSync</span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          <a href="#features" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Features</a>
          <a href="#pricing" className="text-sm text-muted-foreground hover:text-foreground transition-colors">Pricing</a>
          <a href="#faq" className="text-sm text-muted-foreground hover:text-foreground transition-colors">FAQ</a>
        </div>

        <div className="hidden md:flex items-center gap-3">
          <LanguageSwitcher current="en" />
          <Button variant="ghost" asChild>
            <Link to="/auth">Sign in</Link>
          </Button>
          <Button variant="hero" asChild>
            <Link to="/auth?tab=signup">Get Started</Link>
          </Button>
        </div>

        <button aria-label="Toggle menu" className="md:hidden text-foreground" onClick={() => setOpen(!open)}>
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden glass border-t border-border/50 p-4 space-y-3">
          <a href="#features" className="block text-sm text-muted-foreground hover:text-foreground py-2" onClick={() => setOpen(false)}>Features</a>
          <a href="#pricing" className="block text-sm text-muted-foreground hover:text-foreground py-2" onClick={() => setOpen(false)}>Pricing</a>
          <a href="#faq" className="block text-sm text-muted-foreground hover:text-foreground py-2" onClick={() => setOpen(false)}>FAQ</a>
          <div className="pt-3 space-y-2">
            <Button variant="ghost" className="w-full" asChild>
              <Link to="/auth">Sign in</Link>
            </Button>
            <Button variant="hero" className="w-full" asChild>
              <Link to="/auth?tab=signup">Get Started</Link>
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default LandingNav;
